const normalizeHexColor = (value) => {
  const normalized = String(value || "").trim();
  const shortMatch = /^#([0-9a-f]{3})$/i.exec(normalized);
  if (shortMatch) {
    return `#${shortMatch[1]
      .split("")
      .map((character) => `${character}${character}`)
      .join("")}`.toLowerCase();
  }
  return /^#[0-9a-f]{6}$/i.test(normalized)
    ? normalized.toLowerCase()
    : "";
};

const hexToRgb = (value) => {
  const color = normalizeHexColor(value);
  if (!color) return null;
  return [1, 3, 5].map((offset) => parseInt(color.slice(offset, offset + 2), 16));
};

const toHexColor = (channels) =>
  `#${channels
    .map((channel) => Math.max(0, Math.min(255, Math.round(channel))))
    .map((channel) => channel.toString(16).padStart(2, "0"))
    .join("")}`;

const relativeLuminance = (channels) => {
  const [red, green, blue] = channels.map((channel) => {
    const normalized = channel / 255;
    return normalized <= 0.03928
      ? normalized / 12.92
      : ((normalized + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
};

const contrastWithWhite = (channels) =>
  1.05 / (relativeLuminance(channels) + 0.05);

export const resolveAccessibleDeliveryBrandColor = (
  value,
  fallback = "#17436f"
) => {
  const fallbackChannels = hexToRgb(fallback) || [23, 67, 111];
  const originalChannels = hexToRgb(value) || fallbackChannels;

  for (let step = 0; step <= 20; step += 1) {
    const factor = 1 - step * 0.05;
    const candidate = originalChannels.map((channel) => channel * factor);
    if (contrastWithWhite(candidate) >= 4.5) return toHexColor(candidate);
  }

  return toHexColor(fallbackChannels);
};

export const formatDeliveryCheckoutAddress = (profile = {}) => {
  const streetLine = [profile.street, profile.streetNumber]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .join(" ");
  const apartment = [
    profile.floor ? `Piso ${profile.floor}` : "",
    profile.unit ? `Depto ${profile.unit}` : "",
  ].filter(Boolean).join(" · ");

  return [
    streetLine,
    apartment,
    profile.neighborhood,
    profile.city,
    profile.province,
  ]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .join(", ");
};
